"use client";
import React, { useState } from "react";
import ProfitAndLoss from "./profit-loss";
import BalanceSheet from "./balance-sheet";
import { UEListData } from "@/app/interface/homepage";

interface KeyFinancialsProps {
  filteredData: UEListData;
}

const KeyFinancials: React.FC<KeyFinancialsProps> = ({ filteredData}) => {
  const [activeTab, setActiveTab] = useState<"profitAndLoss" | "balanceSheet">(
    "profitAndLoss"
  );

  return (
      <div className="w-full mt-6 max-w-[812px]">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center pb-6 gap-3">
          <h3 className="text-xl font-semibold sm:text-3xl">Key Financials</h3>
          <div className="flex space-x-2">
            <button
              className={`px-4 py-2 text-sm font-medium rounded-[50px] focus:outline-none  ${
                activeTab === "profitAndLoss"
                  ? "text-black bg-orange-100"
                  : "text-gray-700 bg-gray-100"
              }`}
              onClick={() => setActiveTab("profitAndLoss")}
            >
              Profit & Loss
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium rounded-[50px] focus:outline-none ${
                activeTab === "balanceSheet"
                  ? "text-black bg-orange-100"
                  : "text-gray-700 bg-gray-100"
              }`}
              onClick={() => setActiveTab("balanceSheet")}
            >
              Balance Sheet
            </button>
          </div>
        </div>

        <div className="mt-4">
          {activeTab === "profitAndLoss" ? (
            <ProfitAndLoss filteredData={filteredData} />
          ) : (
            <BalanceSheet filteredData={filteredData} />
          )}
        </div>
      </div>
  );
};

export default KeyFinancials;
